import { render, staticRenderFns } from "./SourceControl.vue?vue&type=template&id=aa64d45e&"
import script from "./SourceControl.vue?vue&type=script&lang=js&"
export * from "./SourceControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports